import Flex from '@Components/Bases/Flex';
import { ICGRScore } from '@Domains/Progress';
import { CheckCircle } from '@mui/icons-material';
import ErrorIcon from '@mui/icons-material/Error';
import { Typography } from '@mui/material';
import { formatToThaiDate } from '@Utils/datetime';
import dayjs from 'dayjs';

type CGRScoreSectionProps = {
  cgr: ICGRScore | null;
};

const CGRScoreSection = ({ cgr }: CGRScoreSectionProps) => {
  const PASSING_SCORE = 90;
  const isPass = (cgr?.score ?? 0) >= PASSING_SCORE;

  const getScoreIcon = () => {
    interface IconStyleProps {
      sx: (theme: import('@mui/material/styles').Theme) => {
        color: string;
        mr: number;
      };
    }

    const iconProps = (color: 'warning' | 'success'): IconStyleProps => ({
      sx: (theme) => ({
        color: theme.palette[color].main,
        mr: 1,
      }),
    });

    if (cgr === null || !isPass) {
      return <ErrorIcon {...iconProps('warning')} />;
    }
    return <CheckCircle {...iconProps('success')} />;
  };

  const getScoreText = () => {
    if (cgr === null || cgr.score === null) return 'ไม่มีคะแนน';
    return `${cgr.score} คะแนน`;
  };

  const getScoreColor = () => {
    if (cgr === null) return 'warning';
    return isPass ? 'success' : 'warning';
  };

  const getUpdateDate = () => {
    const date = cgr?.updateDate ?? dayjs(new Date());
    return formatToThaiDate(date);
  };

  return (
    <Typography variant="subtitle2" p={1}>
      <Flex alignItems="center" flexDirection="row">
        1.
        {getScoreIcon()}CGR Score:
        <Typography ml={1} variant="subtitle2" color={getScoreColor()}>
          {getScoreText()}
        </Typography>
      </Flex>
      <Typography
        fontSize={12}
        mt={0.5}
        ml={3}
        bgcolor="primary.lighter"
        width={'fit-content'}
      >
        {`ข้อมูลล่าสุดเมื่อ ${getUpdateDate()}`}
      </Typography>
    </Typography>
  );
};

export default CGRScoreSection;
